import React, { useRef, useState, useEffect, useMemo } from "react";
import MaksuMark from "../assets/images/MaksumärkRotate.JPG";

const createMovingSpeed = (index, scrollY) => {
  let variable = index % 2 ? 1.56 : 0.54;
  variable = index % 3 ? 0.34 : 1.16;
  const arry = [0.3, 0.9, 0.56, 1.5, 0.5, 0.16, 0.4, 0.99, 1.22, 0.9];
  return (scrollY / 100) * arry[index];
};

const Grid = ({ scrollPositionY }) => {
  const gridBox = useRef(null);
  const cellsPerRow = 5;
  const totalCells = cellsPerRow * 3; // TRIPLE for seamless loop (not double)
  const one = 0.25;
  const two = 0.05;
  // Create fixed random data - this ensures no visual jumps
  const cellData = useMemo(() => {
    const data = [];
    for (let row = 0; row < 8; row++) {
      const rowData = [];
      // Create pattern that repeats perfectly
      for (let col = 0; col < cellsPerRow; col++) {
        const rand = Math.random() - one;
        const rand2 = Math.random() + two;
        rowData.push({ rand, rand2 });
      }
      // Duplicate the pattern 3 times for seamless loop
      const fullRowData = [];
      for (let i = 0; i < 3; i++) {
        fullRowData.push(...rowData);
      }
      data.push(fullRowData);
    }
    return data;
  }, []);
  /*
600 = 200
1500 = x

*/

  let posY = 50;
  //let posX =  200 - scrollPositionY / 100 ;

  return (
    <>
      <div className="gridAnim-container" ref={gridBox}>
        <div className="gridAnim">
          <div className="grid">
            {cellData.map((rowData, rowIndex) => (
              <div
                key={rowIndex}
                className="row"
                style={{
                  transform: `translate(-${posY - createMovingSpeed(rowIndex, scrollPositionY)}%,${80}%)`,
                }}
              >
                {rowData.map((cell, cellIndex) => {
                  const { rand, rand2 } = cell;
                  return (
                    <div
                      key={cellIndex}
                      className={`cell ${rand > 0.5 ? "type-1" : rand2 > 0.5 ? "type-2" : "type-3"}`}
                    >
                      {rand > 0.5 && (
                        <img className="maksumark" src={MaksuMark} />
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Grid;
